import { userStore } from '@stores/User';

/**
 * POST /auth/token/exchange/short-lived on the main API. Returns a
 * short-lived exchange token the chat app accepts under `?token=` in
 * place of the long-lived session JWT — so the long-lived token never
 * lands in URLs (browser history, server logs, referrers).
 */
export async function exchangeShortLivedToken(): Promise<string> {
  const { shortExchangeToken } = await userStore.apiWithAuth<{ shortExchangeToken?: string }>(
    '/auth/token/exchange/short-lived',
    { method: 'POST' },
  );
  // Backend fields can be absent at runtime regardless of the declared
  // type — navigating with `?token=undefined` would strand the user on
  // the chat app's auth failure. Throw into the caller's toast path.
  if (!shortExchangeToken) {
    throw new Error('Token exchange response is missing shortExchangeToken');
  }
  return shortExchangeToken;
}
